module.exports = __webpack_public_path__ + "static/img/icon-qq.1d492b4e.png";